module.exports = __webpack_public_path__ + "img/Foto_AutoFach-BJ-5296_2019.872e7002.jpg";